import { Colors } from 'environment';
import styled from 'styled-components';

export const DarkBgContainer = styled.div`
	background-color: ${Colors.background.disabled};
`;
